import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BodyColorModalService {

  private selectedBodyColorSubject = new BehaviorSubject<any>(null);
  public selectedBodyColor$ = this.selectedBodyColorSubject.asObservable();

  constructor() { }

  setSelectedBodyColor(bodyColor: any): void {
    this.selectedBodyColorSubject.next(bodyColor);
  }

  getSelectedBodyColor(): any | null {
    return this.selectedBodyColorSubject.value;
  }

  clearSelectedBodyColor(): void {
    this.selectedBodyColorSubject.next(null);
  }
}
